(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/game-handler/assets/javascripts/helpers.js') >= 0) return;  svs.modules.push('/components/ticketgames/game-handler/assets/javascripts/helpers.js');

const constants = {
  leia: {
    gameConfig: {
      VEIKKAUS: {
        minimumHeight: 320
      },
      default: {
        minimumHeight: 320
      }
    },
    gameEngineCode: {
      VEIKKAUS: 'EIN',
      FDJ: 'ITG'
    },
    lotteryChannel: {
      WEB: 'WEB',
      VOUCHER: 'VOUCHER'
    },
    PROVIDER: 'LEIA',
    currencyFormatter: (val) => val / 100,
    statusFormatter: (status) => {
      switch (status.toLowerCase()) {
        case 'open':
          return 'OPEN';
        case 'suspended':
          return 'SUSPENDED';
        default:
          return 'CLOSED';
      }
    }
  }
};

const mapLeiaGames = (leiaGame) => {
  const { PROVIDER, currencyFormatter, statusFormatter } = constants.leia;
  const { code, name, stakes, state, lotteryGameConfiguration, game, category } = leiaGame;
  const { theme } = lotteryGameConfiguration;
  const status = statusFormatter(state);
  return {
    gameEngineCode: game?.engine?.code,
    name,
    price: stakes && stakes[0]?.value && currencyFormatter(stakes[0].value),
    type: code,
    theme: theme.id,
    provider: PROVIDER,
    status,
    open: status === 'OPEN',
    category,
    gameLoader: game?.gameLoader
  };
};

const log = (msg, type = 'debug') => {
  const logger = svs.core.log.getLogger('components:game-handler');
  logger[type](msg);
};

const validPackageGameSkinId = (packageGameSkinId = null) => {
  const valid = !isNaN(parseInt(packageGameSkinId, 10));
  !valid && svs.ticketgames.gameHandler.helpers.log(`invalid packageGameSkinId ${packageGameSkinId}`, 'warn');
  return valid;
};

const getPackageGameConfig = ({ packageGameThemeName = null, packageGameType, packageGameSkinId = null } = {}, allGames) => {
  let skinId = 1,
    theme, skinUrl, gameToReturn, skin;
  for (let i = 0; i< allGames.length; i++) {
    const game = allGames[i];
    const { type, themeName, themes } = game;
    if (type === packageGameType) {
      theme = themes.find((t) => t.themeName === themeName); 
      skinUrl = theme.skins[skinId - 1].url; 
      skin = theme.skins[skinId - 1].image; 
      if (validPackageGameSkinId(packageGameSkinId)) {
        const cmsTheme = game.themes?.find(({ themeName }) => themeName === packageGameThemeName);
        if (cmsTheme) {
          skinId = Math.abs((packageGameSkinId - 1) % cmsTheme?.skins?.length);
          theme = cmsTheme;
          skinUrl = theme.skins[skinId].url;
          skin = theme.skins[skinId].image;
          skinId = skinId + 1;
        }
      }
      gameToReturn = {
        ...game,
        packageGameConfig: {
          theme,
          skinId,
          skinUrl,
          skin,
          type
        }
      };
      svs.ticketgames.gameHandler.helpers.log(`packageGameType ${type} used with theme ${theme.themeName} and skinId ${skinId}`, 'debug');
      break;
    }
  }

  if (!gameToReturn && !svs.core.config.data.svsconfig.isSelfService) {
    svs.ticketgames.gameHandler.helpers.log(`packageGameType is not set`, 'error');
  }

  return gameToReturn;
};

if (svs.isServer) {
  module.exports = {
    mapLeiaGames
  };
} else {
  setGlobal('svs.ticketgames.gameHandler.constants', constants);
  setGlobal('svs.ticketgames.gameHandler.helpers', {
    mapLeiaGames,
    getPackageGameConfig,
    log
  });
}


 })(window);